import React from 'react'
import styled from '@emotion/styled'

import { colors } from 'Constants'

import { Grid, Flex } from 'lese'

export const TableHead = styled.div`
  display: contents;
  > * {
    align-self: center;
    background-color: ${colors.backgroundInverted};
    ${({ border }) => border && `border-bottom: 1px solid ${colors.borderColor};`}
  }
`

export const TableRow = styled.div`
  display: contents;

  &:nth-of-type(2n + 1) > * {
    ${({ noBackground }) => !noBackground && `background: ${colors.background800};`}
  }

  &:nth-of-type(2n) > * {
    ${({ noBackground }) => !noBackground && `background: ${colors.background700};`}
  }
`

const TableCell = styled(Flex)`
  padding: 16px 8px;
  align-self: stretch;
  break-before: always;

  @media print {
    padding: 8px 4px;
  }
`
TableCell.defaultProps = { yAlign: true }

export { TableCell }

export const ClickableTableCell = styled(TableCell)`
  cursor: pointer;
`

export const TableHeader = styled.div`
  padding: 16px 8px;
  align-self: stretch;
  background-color: ${colors.backgroundInverted};
  color: ${colors.textInverted};
`

export default ({
  columns,
  data,
  Row = TableRow,
  Cell = TableCell,
  Header = TableHeader,
  Head = TableHead
}) => {
  return (
    <>
      <Grid
        columns={`${columns.map(val => val.size?.split('x')[0] || '1').join('fr ')}fr`}
        style={{ width: '100%' }}
      >
        <Head>
          {columns.map(column => (
            <Header {...column}>{column.header}</Header>
          ))}
        </Head>

        {data.map(dataRow => (
          <Row data={dataRow}>
            {columns.map(column => {
              const ColumnCell = column.Cell ?? Cell
              return (
                <ColumnCell data={dataRow} column={column}>
                  {dataRow[column.accessor]}
                </ColumnCell>
              )
            })}
          </Row>
        ))}
      </Grid>
    </>
  )
}
